import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    OnInit,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {finalize, tap} from 'rxjs/operators';
import {DataService} from '../services/data.service';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';
import {DialogCarComponent} from '../dialog-car/dialog-car.component';

@Component({
    selector: 'app-airportcars',
    templateUrl: './airportcars.component.html',
    styleUrls: ['./airportcars.component.css']
})
export class AirportcarsComponent implements OnInit {

    @ViewChild('dialogsContainerAirport', {read: ViewContainerRef, static: true}) dialogsContainer;
    dialogRef: ComponentRef<DialogCarComponent>;

    sessionId: any;
    airportCars: Array<any>;
    showNoCarsMessage = true;

    constructor(private restService: RestService,
                private uiBlockerService: UIBlockerService,
                private dataService: DataService,
                private resolver: ComponentFactoryResolver) { /* noop */
    }

    ngOnInit() {
        // we will simply get the airport cars everytime
        this.sessionId = this.dataService.getSessionIdentifier();
        // try to make the request
        this.makeTheAirportCarsRequest();

        // session id is empty so we must ve after a refesrh so we should wait for data change event and then

        // make the call
        this.dataService.dataChangedSession.subscribe(() => {

            this.sessionId = this.dataService.getSessionIdentifier();
            // try to make the request
            this.makeTheAirportCarsRequest();
        });
    }

    makeTheAirportCarsRequest() {
        if (!isNullOrUndefined(this.sessionId)) {
            // we can make the request
            this.getAirportCars();
        } else { /* noop */
        }
    }

    getAirportCars() {
        this.restService.getAirportCars()
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap(
                    () => {
                        /* noop */
                    },
                    () => {
                        /* noop */
                    }
                )
            ).subscribe((res: any) => {
            if (this.dataService.isResponseSuccessful(res)) {
                this.airportCars = res.CarList;
                if (this.airportCars.length > 0) {
                    this.showNoCarsMessage = false;
                }
            } else {
                // maybe show notification with error getting data
            }
        });
    }

    showCarDetails(carIdentifier: string) {
        this.showDialogForCar(carIdentifier);
    }

    showDialogForCar(carIdentifier: string) {
        const dialogTexts: any = {
            HeaderText: 'Car Details',
            CarIdentifier: carIdentifier
        };
        // Create Dialog Component:
        this.dialogsContainer.clear();
        const factory: ComponentFactory<DialogCarComponent> = this.resolver

            .resolveComponentFactory(DialogCarComponent);
        this.dialogRef = this.dialogsContainer.createComponent(factory);

        // Customize with texts:
        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.carIdentifier = dialogTexts.CarIdentifier;

        // Listen for Dialog Events (Cancel or Confirm):
        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            // for now no action needed
            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            // for now no action needed
            this.dialogRef.destroy();
        });
    }

}
